<template>
  <div class="home">
    <template>
        <!-- Orginal Tourn -->
        <ReportHomeTab
            :data="data"
            :Year="season"
            :code="course"
            :course_code="course_code"
            :reportURL="currentReport"
            :currentReport="reportTitle"
            :title="currentTitle"
            :config="config"
            :home="home"
            :tournDates="tournDates"
            :updateSize="updateSize"
            :widgetHeight="widgetHeight"
            :reports="reports"
            :tourCode="tourCode"
            :show="show"
            :runData="runData"
            :match="match"
            :listFinalAll="listFinalAll"
            :multi_tourns="multi_tourns"
            :smallListTours="smallListTours"
            :nameTourn="name"
            :sponsorLogo="sponsorLogo"
            :roundPlayed="roundPlayed"
            :nameWomen="nameWomen"
        />
        <template v-if="tm_params.play_suspended == 'Y' && tm_params.live_message == 'N'">
        <div class="LiveScoreMessage" v-if="tm_params.play_suspended == 'Y'" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true}">
            <p v-if="tm_params.play_suspended == 'Y'">Play Suspended</p>
        </div>
        </template>
        <template v-else-if="tm_params.play_suspended == 'Y' && tm_params.live_message == 'Y'">
        <div class="LiveScoreMessage" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true}">
            <template v-if="playsus == true">
            <p>Play Suspended</p>
            </template>
            <template v-else>
            <p>
                Play Suspended<br>
                {{tm_params.live_scoring_mess}}
            </p>
            </template>
        </div>
        </template>
        <template v-else-if="tm_params.play_suspended == 'N' && tm_params.live_message == 'Y'">
        <div class="LiveScoreMessage" :class="{mobStyleWid: mobWidget == 'Y' , suspend: playsus == true, suspendBkColor: tm_params.live_message == 'Y'}">
            <p>
            {{tm_params.live_scoring_mess}}
            </p>
        </div>
        </template>
    </template>
  </div>
</template>

<script>
import apiCall from "@/services/api.js";
import ReportHomeTab from "@/components/reportHometab.vue";
import axios from "axios";
export default {
  name: "WPGA home", 
  props: ['config', 'WPGACode', 'season'],
  components: { 
    ReportHomeTab,
  }, // Everything below on every /view/<Page Name>.vue for meta info and all ACF data
  data: function() {
    return {
      title: [], //Page Title
      description: [], //Meta Description
      homepage: true,
      home: true,
      wphome: [],
      inter: "5",
      pro: "44",
      latestsm: "29",
      latestFull: "8",
      featHome: "true",
      data: [],
      reports: [],
      course: this.WPGACode,
      seasonCur: this.season,
      course_code: [],
      tm_params:[],
      mobWidget: process.env.VUE_APP_MOB_WIDGET,
      // tourCode: '',
      tourCode: [],
      NextTournCode: [],
      text: '',
      NewWidgetHeight: '',
      NewMinheight: '',
      NewMaxheight: '',
      activeTab: '',
      scores_available: '',
      showReports: '',
      results_available: '',
      smallListTours: [],
      FullListT: [],
      show: false,
      runData: 'N',
      url: '',
      multi_tourns: '',
      finalFilter: [],
      firstArray: [],
      listFinalAll:[],
      EveryTour: [],
      switch: false,
      code: this.WPGACode,
      playsus: false,
      name: '',
      namecourse: '',
      timediff: '',
      until: '',
      codeRolex: '',
      updateSize: '',
      widgetHeight: '',
      upComingAus: [],
      upComingWPG: [],
      sponsorLogo: '',
      roundPlayed: '',
      nameWomen:'',
      showReport: true,
      tournamentName: ''
    };
  },
  methods: {
    myFunction: function() {
      let h = window.outerWidth;
      let txt = h;
      this.text = txt;
      if (this.text == 1400 || this.text > 1401) {
        // this.NewWidgetHeight = '669px!important'
        if (this.mobWidget == 'Y') {
          this.NewWidgetHeight = '300px!important' 
        } else {
          // if (this.multi_tourns == 'Y') {
          //   this.NewWidgetHeight = '570px!important'   
          //   this.NewMinheight = '570px!important'     
          //   this.NewMaxheight = '570px!important'            
          // } else {
          //   this.NewWidgetHeight = '589px!important'     
          //   this.NewMinheight = '589px!important'     
          //   this.NewMaxheight = '589px!important'                      
          // }
            this.NewWidgetHeight = '589px!important'     
            this.NewMinheight = '589px!important'     
            this.NewMaxheight = '589px!important'    
        }
      } else if(this.text == 1400 || this.text == 1397) {
        this.NewWidgetHeight = '473px!important'
        this.NewMinheight = '473px!important'     
        this.NewMaxheight = '473px!important'  
      } else if(this.text < 1400  && this.text > 1200) {
        // this.NewWidgetHeight = '555px!important'
        this.NewWidgetHeight = '473px!important'
        this.NewMinheight = '473px!important'     
        this.NewMaxheight = '473px!important'  
      } else if(this.text < 1199) {
         if (this.mobWidget == 'Y') {
          // this.NewWidgetHeight = '399px!important' 
          this.NewWidgetHeight = '399px!important' 
        } else {
          this.NewWidgetHeight = '411px!important'
          this.NewMinheight = '411px!important'     
          this.NewMaxheight = '411px!important'  
          this.playsus = true
        }
      } else if(this.text < 1400  && this.text > 1199) {
        this.NewWidgetHeight = '473px!important'
        this.NewMinheight = '473px!important'     
        this.NewMaxheight = '473px!important' 
      }
    },
    async updateStuff() {
      try {
        // First call, await for call to return
        // let first_call = await apiCall.tmParamsYear(this.season);
        // this.tm_params = first_call.data;
        // this.loading = false;
        // Second call, await for call to return

        let first_call = await apiCall.report(this.reportTitle);
        this.data = first_call.data;
        this.loading = false;
      } catch (error) {
        console.log("error in await calls");
        console.log(error);
        throw error;
      }
    },
  },
  mounted() {
    axios
        .get(
            process.env.VUE_APP_TIC_BASE +
            'wpg/' +
            this.seasonCur +
            "/" +
            this.seasonCur +
            "-" +
            this.WPGACode +
            "-tmticx.json?randomaddMount=" +
            new Date().getTime()
        )
      .then(response => {
        this.tm_params = response.data;
        this.tournamentName = response.data.short_name;
        this.multi_tourns = response.data.multi_tourns;
        this.match = response.data.match_play;
        this.course = response.data.code;
        this.namecourse = response.data.course_city;
        this.timediff = response.data.time_diff_dec;
        this.until = response.data.days_away;
        this.codeRolex = response.data.code;
        
        this.daysAway = parseInt(response.data.days_away);
        if (this.daysAway > 5) {
          this.showReports = 'N'
        } else {
          this.showReports = 'Y'
        }
        this.season = response.data.tm_params.season_code;
        this.course_code = response.data.course_code;
        this.tournDates = response.data.dic_dates;
        this.name = response.data.short_name;
        this.sponsorLogo = response.data.sponsor_logo;
        this.roundPlayed = response.data.rounds_played;
        this.scores_available = response.data.scores_available;
        this.ts_round_status_1 = response.data.ts_round_status_1;
        this.firstArray = [
          {
            'name': this.name,
            'code': this.course,
          }
        ]
        this.reports = response.data.reports.reports_entry;
        this.reportsStart = response.data.reports;
        this.pastTourns = response.data.past_tourns;
        this.futureTourns = response.data.future_tourns;
        if (this.pastTourns != '') {
          if (Array.isArray(response.data.past_tourns.past_tourns_entry)) {
            this.past_tourns = response.data.past_tourns.past_tourns_entry;
          } else {
            this.past_tourns = [response.data.past_tourns.past_tourns_entry];
          }
          var listFinal =  this.firstArray.concat(this.past_tourns);
          this.listFinalAll = listFinal;          
        } else if (this.futureTourns !== '') {
          if (Array.isArray(response.data.future_tourns.future_tourns_entry)) {
            this.past_tourns = response.data.future_tourns.future_tourns_entry;
          } else {
            this.past_tourns = [response.data.future_tourns.future_tourns_entry];
          }
          var listFinals=  this.firstArray.concat(this.past_tourns);
          this.listFinalAll = listFinals;
        }
        if (this.reportsStart != '') {
          let arr = [];
          this.results_available = arr;
          if (Array.isArray(this.reports)) {
            this.reports.forEach((value) => {
                if (value.report_title.includes('Result')) {
                  arr.push(value.report_title);
                  // console.log(value); 
                }
            });  
          }
        }
        window.addEventListener('resize', this.myFunction);
        this.myFunction();
        console.clear();
        this.loading = false;
      })
  },
  computed: {
    filterTournaments: function() {
      return this.smallListTours.filter(
        value =>
          value.days_away == '0',
      );
    },
    filterTournamentsOne: function() {
      return this.smallListTours.filter(
        value =>
          value.days_away == '1',
      );
    },
    filterTournamentsTwo: function() {
      return this.smallListTours.filter(
        value =>
          value.days_away == '2',
      );
    },
    filterTournamentsThree: function() {
      return this.smallListTours.filter(
        value =>
          value.days_away == '3'
      );
    },
    filterTournamentsFour: function() {
      return this.smallListTours.filter(
        value =>
          value.days_away == '4'
      );
    },
    
    filterReport: function() {
      if (Array.isArray(this.reports)) {
        return this.reports.filter(
          (reports_entry) =>
            reports_entry.report_title.includes("Tournament Entries") ||
            // reports_entry.report_title == 'Round 1 Draw' ||
            reports_entry.report_title.includes("Score") ||
            // reports_entry.report_title.includes("Live") ||
            reports_entry.report_title.includes("Final")
        );
      } else return this.reports; 
    },

    currentReport() {
      if (Array.isArray(this.filterReport))
        return this.filterReport[this.filterReport.length - 1].report_url;
      else return this.reports.report_url;
    },
    currentTitle() {
      if (Array.isArray(this.filterReport))
        return this.filterReport[this.filterReport.length - 1].report_title;
      else return this.reports.report_title;
    },
    reportTitle: function(url) {
        if (this.currentReport.indexOf("tmentry") !== -1) {
          url =
            this.config.VUE_APP_TIC_BASE +
            'wpg' +
            "/" +
            this.tm_params.tm_params.season_code +
            "/" +
            this.tm_params.tm_params.season_code +
            "-" +
            this.course +
            "-entryw-entries.json?Mattrandomadd=" +
            new Date().getTime();
        } else {
          if (this.currentReport.indexOf("tmscore") !== -1) {
            var subRep3 = this.currentReport.lastIndexOf("params=") + 7;
            var indNext3 = this.currentReport.indexOf("~", subRep3);
            var repParams1 = this.currentReport.substr(
              subRep3,
              indNext3 - subRep3
            );
            if (repParams1 && repParams1.indexOf(".cgi") < 0) {
              url =
                this.config.VUE_APP_TIC_BASE +
                'wpg' +
                "/" +
                this.season +
                "/" +
                this.season +
                "-" +
                // this.course +
                this.course +
                "-scores-" +
                repParams1 +
                ".json" +
                "?randomadd=" +
                new Date().getTime();
              // var url = "http://dev-auspga.ocs-software.com/api/" + "dev" + "/cache/" + "dev" + "/" + "215S" + "/" + "215S" + "-" + "AUS7" + "-scores-" + $scope.repParams + ".json"+"?randomadd=1603894106415";
            } else {
              url =
                this.config.VUE_APP_TIC_BASE +
                'wpg'  +
                "/" +
                this.season +
                "/" +
                this.season +
                "-" +
                this.course +
                "-scores-latest.json" +
                "?gt=y&randomadd=" +
                new Date().getTime();
              // var url = "http://dev-auspga.ocs-software.com/api/dev/cache/dev/215S/215S-AUS7-scores-latest.json?gt=y&randomadd=1573131881374"
            }
          } else if (this.currentReport.indexOf("tmlsmon") !== -1) {
            {
              url =
                this.config.VUE_APP_TIC_BASE +
                'wpg'  +
                "/" +
                this.season +
                "/" +
                this.season +
                "-" +
                this.course +
                "-scores-latest.json" +
                "?gt=y&randomadd=" +
                new Date().getTime();
              // var url = "http://dev-auspga.ocs-software.com/api/dev/cache/dev/215S/215S-AUS7-scores-latest.json?gt=y&randomadd=1573131881374"
            }
          } else if (this.currentReport.indexOf("tmdraw") !== -1) {
            var subRep6 = this.currentReport.lastIndexOf("round=") + 6;
            var indNext6 = this.currentReport.indexOf("~", subRep6);
            var drawRnd6 = this.currentReport.substr(subRep6, indNext6 - subRep6);
            url =
              this.config.VUE_APP_TIC_BASE +
              'wpg'  +
              "/" +
              this.season +
              "/" +
              this.season +
              "-" +
              this.course +
              "-draw-R" +
              drawRnd6 +
              "-draw.json" +
              "?randomadd=" +
              new Date().getTime();
          } else if (this.currentReport.indexOf("tmresult") !== -1) {
            var subRep5 = this.currentReport.lastIndexOf("result=") + 7;
            var indNext5 = this.currentReport.indexOf("~", subRep5);
            var resNum5 = this.currentReport.substr(subRep5, indNext5 - subRep5);
            console.log("resNum === ");
            console.log(resNum5);
            url =
              this.config.VUE_APP_TIC_BASE +
              'wpg'  +
              "/" +
              this.season +
              "/" +
              this.season +
              "-" +
              this.course +
              "-result-result-" +
              resNum5 +
              ".json" +
              "?randomadd=" +
              new Date().getTime();
          } else {
            url =
              this.config.VUE_APP_TIC_BASE +
              'wpg'  +
              "/" +
              this.season +
              "/" +
              this.season +
              "-" +
              this.course +
              "-result-result-PF.json" +
              "?randomadd=" +
              new Date().getTime();
          }
        }
      return url;
    },
  },
  created() {
    localStorage.clear();
    // this.myFunction();
    // window.addEventListener('resize', this.myFunction);
    setInterval(
      console.log('In Interval 270'),
      this.updateSize, 12000,
      this.updateStuff, 120000,
      console.log('In Interval 272')
    );
    // this.getAllTourns();
    this.reportListText();
    // this.getReports(current);
  },
};
</script>
<style scoped>
::v-deep .dropdown.b-dropdown.mobileDropdown.btn-group {
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  vertical-align: middle;
  border: 0px solid #ced4da;
  border-radius: 0.25rem;
  color: #495057;
}
::v-deep .dropdown.b-dropdown.mobileDropdown.btn-group > button {
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  background-color: #fff;
  text-align: left;
}
::v-deep .dropdown-toggle::after {
  text-align: right;
  float: right;
  position: relative;
  top: 10px;
}
::v-deep ul.dropdown-menu.show {
  width: 100%;
}
::v-deep .dropdown-item {
  color: #000!important;
}
option.showNone {
  display: none;
}
.suspendBkColor {
  background-color: blue!important;
}
.suspend {
  position: absolute;
  bottom: 0!important;
  background: red!important;
  width: 100%!important;
  text-align: center;
  color: #fff;
  padding-left: 20px;
  padding-right: 23px;
}
::v-deep option.opt-arrow.showNone {
  display: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
}
.RolexSection {
  margin-top: 6px;
}
.colClass {
  padding: 0!important;
}
.LiveScoreMessage {
  position: absolute;
  bottom: 66px;
  background: red;
  width: 93%;
  text-align: center;
  color: #fff;
  /* white-space: nowrap; */
  /* overflow: hidden; */
  padding-left: 20px;
  padding-right: 23px;
}
.mobStyleWid {
  width: 100%!important;
  bottom: 2px!important;
}
.LiveScoreMessage > p {
  margin-bottom: 0;
  padding-top: 10px;
  padding-bottom: 10px;
}
.TournDrop {
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 15px;
}
::v-deep li.nav-item.tabsStyle.tabWidth {
  width: 50%;
}
::v-deep .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: transparent;
}
::v-deep .tabone {
  width: 27%;
}
::v-deep .tabtwo {
  width: 40%;
}
::v-deep .tabthree {
  width: 33%;
}
.homeHeight {
  /* height: 669px; */
  /* height: 605px; */
  height: 589px;
}
.HomehomeReport-list {
  border: 1px solid #E6E6E6;
}
::v-deep li.nav-item.tabsStyle {
  /* width: 33%; */
}
::v-deep li.nav-item.tabsStyle > a{
  /* padding-left: 13px!important;
  padding-right: 10px!important; */
}
::v-deep .nav-tabs .nav-link:hover {
  cursor: default;
  background-color: #dfe1e6;
  border-bottom-color: transparent;
  border-radius: 0px 0px 0px 0px !important;
  height: 38px;
  font-family: "proxima-nova, sans-serif", sans-serif !important;
  font-weight: 700;
  font-style: normal;
  font-size: 13px;
  color: #00433e !important;
  padding-left: 18px;
  padding-right: 20px;
  text-align: center;
}
::v-deep .nav-tabs .nav-link.active {
  cursor: default;
  background-color: #fff;
  border-bottom-color: transparent;
  border-radius: 0px 0px 0px 0px !important;
  height: 38px;
  font-family: "proxima-nova, sans-serif", sans-serif !important;
  font-weight: 700;
  font-style: normal;
  font-size: 14px;
  color: #34caa9 !important;
  padding-left: 18px;
  padding-right: 20px;
  border-bottom: 0px solid #dee2e6;
  padding-top: 14px;
  padding-bottom: 35px;
  border: none!important;
}
::v-deep .nav-tabs .nav-link {
  cursor: default;
  background-color: #E6E6E6;
  color: #B8B8B8 !important;
  border-bottom-color: transparent;
  border-radius: 0px 0px 0px 0px !important;
  height: 38px;
  font-family: "proxima-nova, sans-serif", sans-serif !important;
  font-weight: 700;
  font-style: normal;
  font-size: 14px;
  padding-left: 18px;
  padding-right: 20px;
  border-bottom: 0px solid #dee2e6;
  text-align: center;
  padding-top: 14px;
  padding-bottom: 35px;
  border: none!important;
}
::v-deep .nav-tabs {
    border-bottom: 0px solid #dee2e6;
}
/* ::v-deep .tabWhite { 
  padding-top: 0em;
  height: 581px;
} */
.home {
  background-color: #fff;
}
.title {
  font-weight: 500;
  font-family: "proxima-nova, sans-serif", sans-serif !important;
  color: #000;
  font-size: 23pt;
  margin-top: 1em;
  line-height: 1.1;
  /* letter-spacing: 2px; */
}

.ad {
  padding: 15px 0; 
}

.bottomAdBanner {
  width: 100%;
}
.sections {
  padding: 30px 0;
}
.box {
  display: block;
  top: 0px;
  border-radius: 4px;
  position: relative;
  text-decoration: none;
  z-index: 0;
  overflow: hidden;
}

.box:hover {
  transition: all 0.3s ease;
  box-shadow: 0px 4px 8px rgba(38, 38, 38, 0.2);
  top: -4px;
  background-color: white;
}
@media only screen and (max-height: 1024px) {
  .homeReport-list {
    /* height: auto !important; */
  }
}

@media only screen and (max-height: 990px) {
  ::v-deep option.opt-arrow.showNone {
    display: block;
    -webkit-appearance: block;
    -moz-appearance: block;
    -o-appearance: block;
    appearance: block;
  }
}
@media only screen and (min-height: 501px) {
  .homeContainer.container {
    padding-left: 0px!important;
    padding-right: 0px!important;
  }
  ::v-deep option.opt-arrow.showNone {
    display: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
  }
}
@media only screen and (max-height: 500px) {
  .mobileWidth {
    padding-left: 0px;
    padding-right: 0px!important;
  }
}
@media only screen and (max-height: 430px) {
  ::v-deep .nav-tabs .nav-link.active {
    cursor: default;
    background-color: #fff;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 38px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 14px;
    color: #34caa9 !important;
    padding-left: 18px;
    padding-right: 20px;
    border-bottom: 0px solid #dee2e6;
    padding-top: 15px;
    padding-bottom: 35px;
    border: none!important;
  }
  ::v-deep .nav-tabs .nav-link {
    cursor: default;
    background-color: #E6E6E6;
    color: #B8B8B8 !important;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 38px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 14px;
    padding-left: 18px;
    padding-right: 20px;
    border-bottom: 0px solid #dee2e6;
    text-align: center;
    padding-top: 15px;
    padding-bottom: 35px;
    border: none!important;
  }
  .mobileWidth {
    padding-left: 0px;
    padding-right: 0px!important;
  }
}
.mobWidgetPad {
  height: 476px!important;
}


@media only screen and (max-width: 480px) {
  .bottomAdBanner{
    padding: 15px 0;
  }
  .hero-plus__html-content iframe {
    width: 94%!important;
    height: 980px!important;
  }
}

@media only screen and (max-width: 419px) {
  ::v-deep .nav-tabs .nav-link.active {
    cursor: default;
    background-color: #fff;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 38px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 13px;
    color: #34caa9 !important;
    padding-left: 5px;
    padding-right: 5px;
    border-bottom: 0px solid #dee2e6;
    border: none!important;
  }
  ::v-deep .nav-tabs .nav-link {
    cursor: default;
    background-color: #E6E6E6;
    color: #B8B8B8 !important;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 38px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 13px;
    padding-left: 5px;
    padding-right: 5px;
    border-bottom: 0px solid #dee2e6;
    text-align: center;
    border: none!important;
  }
}

@media only screen and (max-width: 400px) {
  ::v-deep option.hideMobNow {
    display: none!important;
  }
  ::v-deep .nav-tabs .nav-link.active {
    cursor: default;
    background-color: #fff;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 28px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 11px;
    color: #34caa9 !important;
    padding-left: 18px;
    padding-right: 20px;
    border-bottom: 0px solid #dee2e6;
    border: none!important;
    padding-top: 5px;
    padding-bottom: 5px !important;
  }
  ::v-deep .nav-tabs .nav-link {
    cursor: default;
    background-color: #E6E6E6;
    color: #B8B8B8 !important;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 28px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 11px;
    padding-left: 18px;
    padding-right: 20px;
    border-bottom: 0px solid #dee2e6;
    text-align: center;
    border: none!important;
    padding-top: 5px;
    padding-bottom: 5px !important;
  }
  ::v-deep .nav-tabs .nav-link:hover {
    cursor: default;
    background-color: #dfe1e6;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 28px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 11px;
    color: #00433e !important;
    padding-left: 18px;
    padding-right: 20px;
    text-align: center;
    padding-top: 5px;
    padding-bottom: 5px !important;
  }
}
@media only screen and (max-width: 321px) {
  ::v-deep .nav-tabs .nav-link.active {
    cursor: default;
    background-color: #fff;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 28px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 11px;
    color: #34caa9 !important;
    padding-left: 10px;
    padding-right: 15px;
    border-bottom: 0px solid #dee2e6;
    border: none!important;
    padding-top: 5px;
    padding-bottom: 5px !important;
  }
  ::v-deep .nav-tabs .nav-link {
    cursor: default;
    background-color: #E6E6E6;
    color: #B8B8B8 !important;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 28px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 11px;
    padding-left: 10px;
    padding-right: 15px;
    border-bottom: 0px solid #dee2e6;
    text-align: center;
    border: none!important;
    padding-top: 5px;
    padding-bottom: 5px !important;
  }
  ::v-deep .nav-tabs .nav-link:hover {
    cursor: default;
    background-color: #dfe1e6;
    border-bottom-color: transparent;
    border-radius: 0px 0px 0px 0px !important;
    height: 28px;
    font-family: "proxima-nova, sans-serif", sans-serif !important;
    font-weight: 700;
    font-style: normal;
    font-size: 11px;
    color: #00433e !important;
    padding-left: 10px;
    padding-right: 15px;
    text-align: center;
    padding-top: 5px;
    padding-bottom: 5px !important;
  }
}
@media only screen and (max-width: 375px) {
  .mobileWidth {
    padding-left: 0px;
    padding-right: 0px;
  }
}
</style>
